module.exports = __webpack_public_path__ + "static/media/white-bg.98cfb205.png";